<template>
  <div class="titlepara">
    <b-col md="12" sm="12">
      <h4 class="heading-text">{{para.title}}</h4>
      
       <div  v-for="(prgph, index) in para.paragraph"
                :key="index">
                 <ul v-if="prgph.subpoint" class="list-data">
                  <li
                    v-for="(point,index) in prgph.line"
                    :key="index"
                    class="text text-justify "
                  >{{point.point}}</li>
                </ul>
                <p class="text text-justify" v-else>{{prgph.line}}</p>
                </div>
        <!--<ul v-if="para.paragraph.subpoint" class="list-data">
                  <li
                    v-for="(point,index) in para.paragraph"
                    :key="index"
                    class="text-justify "
                  >lol{{point.point}}</li>
                </ul>
                <p class=" text text-justify" v-else>{{para.paragraph}}</p>
     <p class="text">{{para.paragraph}}</p> -->
    </b-col>
  </div>
</template>
<script>
export default {
  name: "Titlepara",
  props: ["para"],
};
</script>
<style scoped>
ul{
  padding-left:15px;
}
.heading-text {
  color: var(--mainBlueColor);
  background: transparent;
  border: none;
  margin-bottom: 1.25rem;
  margin-top: 1.25rem;
  text-align: left;
}
.text {
  color:var(--mainBlueColor);
  font-size: 16px;
  font-weight: 500;
  text-align: justify;
  /*  text-indent: 1.25rem; */
}

@media (max-width: 767px) {
  .text {
    font-size: 0.75rem;
  }
  .heading-text {
    font-size: 1.4rem;
  }
}
</style>